<script setup>
import { ref } from 'vue';

const emit = defineEmits(['method']);
const props = defineProps({
  invert: Boolean,
  transparent: Boolean,
  minWidth: String,
  width: String,
  disabled: Boolean,
  disabledTooltip: String,
  preventDefault: {
    type: Boolean,
    default: true,
  },
});

const minWidth = ref(props.minWidth || 210);

function clickHandler(e) {
  if (props.preventDefault) {
    e.preventDefault();
  }
  emit('method');
}
</script>

<template>

  <button
    :disabled="disabled"
    class="
      relative
      h-14
      font-FordAntennaCondReg
      text-lg
      group
    "
    :style="{ 'min-width': `${minWidth}px` }"
    @click="clickHandler"
    @keydown.enter="clickHandler"
    @keydown.space="clickHandler"
  >
    <div v-if="(disabled && disabledTooltip)"
      class="
        absolute
        hidden
        top-[-75%]
        text-center
        w-full
        left-0
        group-hover:block
        z-10
        bg-white
        shadow
        p-2
      "
    >
      {{ disabledTooltip }}
    </div>
    <span
      class="
        absolute
        top-0
        w-full
        h-full
        block
        border
        rounded-full
        transition-all
        group-hover:scale-105
        group-disabled:scale-100
        group-disabled:bg-slate-400
        group-disabled:border-slate-400
      "
      :class="
        invert
          ? `
          bg-white
          border-ford-blue-dark
          group-hover:border-ford-blue-electric
          `
          : transparent
          ? `
          bg-transparent
          border-ford-blue-dark
          group-hover:border-ford-blue-electric
          group-hover:bg-ford-blue-electric
          group-hover:bg-opacity-5
          `
          : width
          ? 'min-w-0'
          : 'border-ford-blue-dark bg-ford-blue-dark group-hover:bg-ford-blue-electric'
      "
    ></span>
    <span
      class="absolute top-0 w-full h-full flex items-center justify-center"
      :class="
        invert
          ? 'text-ford-blue-dark group-hover:text-ford-blue-electric'
          : transparent
          ? 'group-hover:text-ford-blue-electric'
          : width
          ? 'min-w-0'
          : 'text-white'
      "
    >
      <slot></slot>
    </span>
  </button>
</template>
